import type { FogBugzCase } from "@/hooks/queries/use-fogbugz";
import { Badge } from "@/components/ui/badge";
import { CaseRow } from "@/pages/fogbugz/components/case-row";

interface AreaSubGroupProps {
  areaName: string;
  cases: FogBugzCase[];
  onNavigate: (id: number) => void;
}

/**
 * Renders as table rows — must be used inside a <tbody>.
 * Includes a sub-header row followed by CaseRow rows.
 */
export function AreaSubGroup({ areaName, cases, onNavigate }: AreaSubGroupProps) {
  return (
    <>
      <tr className="bg-muted/30 border-b">
        <td colSpan={5} className="px-4 py-2">
          <div className="flex items-center gap-2">
            <span className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              {areaName}
            </span>
            <Badge variant="secondary" className="text-xs h-4 px-1.5">
              {cases.length}
            </Badge>
          </div>
        </td>
      </tr>
      {cases.map((caseItem) => (
        <CaseRow key={caseItem.ixBug} caseItem={caseItem} onNavigate={onNavigate} />
      ))}
    </>
  );
}
